import api from "./axios";

export const searchFloorMaps = (payload) =>
  api.post("/floor-map/search", payload);

export const getFloorMapById = (id) =>
  api.get(`/floor-map/${id}`);

export const createFloorMap = (data) =>
  api.post("/floor-map", data);

export const updateFloorMap = (id, data) =>
  api.put(`/floor-map/${id}`, data);

export const deleteFloorMap = (id, payload) =>
  api.put(`/floor-map/delete/${id}`, payload);

export const publishFloorMap = (id, payload) =>
  api.put(`/floor-map/${id}/publish`, payload);

export const uploadBackground = (id, floorId, formData) =>
  api.post(`/floor-map/${id}/upload-background/${floorId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const getStalls = (payload) =>
  api.post("/floor-map/stalls/search", payload);

export const saveStalls = (payload) =>
  api.post("/floor-map/stalls/save", payload);

export const uploadStallImage = (formData) =>
  api.post("/floor-map/stalls/upload-image", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
